<template>
  <div class="help-card-wrap">
    <div class="help-card-content">
      <slot></slot>
    </div>
    <i class="help-card-close el-icon-close" @click="closeHelpCard"></i>
  </div>
</template>

<script>
export default {
  methods: {
    closeHelpCard() {
      this.$emit('closeHelpCard');
    }
  },
}
</script>

<style lang="scss" scoped>
  .help-card-wrap {
    position: relative;
    width: 100%;
    padding: 8px 16px;
    margin: 0 0 10px 0;
    box-sizing: border-box;
    background: #FFFBE8;
    overflow: hidden;
    opacity: 1;
    display: flex;
    align-items: center;
    transition: opacity .2s;
    border-radius: 8px;
    .help-card-content {
      display: table-cell;
      padding: 0 8px;
      .help-card-title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #654618;
        line-height: 20px;
      }
      .help-card-description {
        margin: 5px 0 0 0;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9B6C1E;
        line-height: 17px;
        .link-doc {
          cursor: pointer;
          text-decoration: underline;
          color: #3192F1;
          &:hover {
            opacity: 0.8;
          }
        }
        span {
          color: #de1936;
        }
      }
    }
    .help-card-close {
      position: absolute;
      top: 12px;
      right: 15px;
      font-size: 20px;
      opacity: 1;
      cursor: pointer;
      color: #9B6C1E;
    }
  }
</style>